function getMonthName(number) {
    return [
        gettext('1699'), gettext('1701'), gettext('1703'), gettext('1705'),
        gettext('1721'), gettext('1707'), gettext('1709'), gettext('1711'),
        gettext('1713'), gettext('1715'), gettext('1717'), gettext('1719')
    ][number];
}

function getDaysInMonth(month, year) {
    return new Date(year, month + 1, 0).getDate();
}

function getTimeText(hours, minutes) {
    return _.padStart(hours, 2, '0') + ':' + _.padStart(minutes, 2, '0');
}

function getHoursAndMinutes(timeText) {
    return timeText.split(':');
}


class Store {
    @mobx.observable date
    @mobx.observable useNow
    @mobx.observable showTime
    @mobx.observable useExtraOption
    @mobx.observable extraOptionValue
    @mobx.observable extraOptionLabel

    enableUseNowOption
    enableShowTimeToggler
    enableExtraOption
    extraOptionDefaultValue
    extraOptionCreator
    onChange
    minDate

    setDate(date) {

        // Set seconds and miliseconds to 0, because the interface doesn't
        // provide that precision, and if we don't reset it to 0 it defaults to
        // the "current" seconds/miliseconds. This can result in tickets that
        // seem to have the same time, to be off by some seconds/miliseconds.
        date.setSeconds(0);
        date.setMilliseconds(0);

        this.date = date;
        this.useNow = false;
        this.useExtraOption = false;
        this.triggerOnChange();
    }

    toggleUseNow(useNow) {
        this.useNow = !this.useNow;

        if (this.useNow) {
            this.date = new Date();
            this.useExtraOption = false;
        }

        this.triggerOnChange();
    }

    toggleShowTime() {
        this.showTime = !this.showTime;
        this.triggerOnChange();
    }

    handleToggleUseExtraOption = () => {
        this.setUseExtraOption(!this.useExtraOption);
    }

    setUseExtraOption(useExtraOption) {
        this.useExtraOption = useExtraOption;

        if (!this.extraOptionValue && this.extraOptionDefaultValue) {
            this.extraOptionValue = this.extraOptionDefaultValue();
        }

        this.useNow = false;
        this.triggerOnChange();
    }

    setExtraOptionValue(value, label) {
        this.useExtraOption = true;
        this.extraOptionValue = value;
        this.extraOptionLabel = label;
        this.useNow = false;
        this.triggerOnChange();
    }

    getExtraOptionLabel() {
        if (this.extraOptionLabelForValue) {return this.extraOptionLabelForValue(this.extraOptionValue);}
    }

    createExtraOption() {
        return this.extraOptionCreator(
            this.useExtraOption,
            this.setExtraOptionValue.bind(this),
            this.setUseExtraOption.bind(this)
        );
    }

    triggerOnChange() {
        if (!this.onChange) return;

        this.onChange({
            date: this.date,
            showTime: this.showTime,
            useNow: this.useNow,
            useExtraOption: this.useExtraOption,
            extraOptionValue: this.extraOptionValue
        });
    }
}


@mobxReact.observer
export default class DateTimePicker extends React.Component {
    constructor(props) {
        super(props);
        this.store = new Store();
        this.dateTimePickerEl = null;
        this.updateStore(props);
        this.state = { pickerOpen: false };
    }

    componentWillReceiveProps(props) {
        this.updateStore(props);
    }

    componentDidMount() {
        this.onClickEventListener = event => {
            if (
                this.state.pickerOpen &&
                this.dateTimePickerEl &&
                !this.dateTimePickerEl.contains(event.target)
            ) {
                this.closePicker();
            }
        };

        document.addEventListener('click', this.onClickEventListener);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.onClickEventListener);
    }

    updateStore(props) {
        this.store.date = props.date || new Date();
        this.store.useNow = Boolean(props.useNow);
        this.store.showTime = typeof props.showTime == 'undefined' ? true : props.showTime;
        this.store.enableShowTimeToggler = (
            props.enableShowTimeToggler || (typeof props.showTimeInputName != 'undefined')
        );
        this.store.useExtraOption = Boolean(props.useExtraOption);
        this.store.extraOptionDefaultValue = props.extraOptionDefaultValue;
        this.store.enableUseNowOption = Boolean(props.useNowInputName) || Boolean(props.enableUseNowOption);
        this.store.extraOptionCreator = props.extraOptionCreator;
        this.store.extraOptionLabelForValue = props.extraOptionLabelForValue;
        this.store.onChange = props.onChange;
        this.store.minDate = props.minDate;

        if (props.extraOptionDefaultValue) {
            this.store.extraOptionValue = props.extraOptionDefaultValue();
        }
    }

    render() {
        return (
            <span style={getStyle()} ref={ref => {this.dateTimePickerEl = ref;}}>
                <span style={getTogglerStyle()} onClick={this.handleTogglePicker}>
                    {this.getDateTimeAsText()}
                </span>
                {this.getDateTimePickerPopover()}
                <input type='hidden' name={this.props.dateInputName} value={this.store.date.toISOString()} />
                <input type='hidden' name={this.props.showTimeInputName} value={+this.store.showTime} />
                <input type='hidden' name={this.props.useNowInputName} value={+this.store.useNow} />
                <input type='hidden' name={this.props.useExtraOptionInputName} value={+this.store.useExtraOption} />
                <input
                    type='hidden'
                    name={this.props.extraOptionInputName}
                    value={this.store.useExtraOption ? this.store.extraOptionValue || '' : ''}
                />
            </span>
        );

        function getStyle() {
            return {
                display: 'flex', // This fixes an issue with positioning the
                // popover in some circumstances.
                position: 'relative'
            };
        }

        function getTogglerStyle() {
            return {
                display: 'inline-block',
                overflow: 'hidden',
                padding: 7,
                maxWidth: 220,
                borderRadius: 5,
                background: '#AD4C2C',
                color: 'white',
                cursor: 'pointer',
                userSelect: 'none',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            };
        }
    }

    getDateTimePickerPopover() {
        if (this.state.pickerOpen) {
            return <DateTimePickerPopover store={this.store} />;
        }
    }

    getDateTimeAsText() {
        if (this.store.useNow) return gettext('3188');

        if (this.store.useExtraOption && this.store.getExtraOptionLabel()) {
            return this.store.getExtraOptionLabel();
        }

        return (
            this.getDateAsText() +
            (this.store.showTime ? ' ' + this.getTimeAsText() : '')
        );
    }

    getDateAsText() {
        return (
            this.store.date.getDate() +
            ' ' + getMonthName(this.store.date.getMonth()) +
            ' ' + this.store.date.getFullYear()
        );
    }

    getTimeAsText() {
        return getTimeText(
            this.store.date.getHours(),
            this.store.date.getMinutes()
        );
    }

    handleTogglePicker = event => {
        if (this.state.pickerOpen) {
            this.closePicker();
        } else {
            this.openPicker();
        }
    }

    openPicker() {
        this.setState({ pickerOpen: true });
    }

    closePicker() {
        this.setState({ pickerOpen: false });
    }
}


class DateTimePickerPopover extends React.Component {
    PropTypes = {
        store: PropTypes.object.required
    }

    render() {
        return (
            <span style={getStyle()}>
                <span style={getArrowUpStyle()} />
                <DatePicker store={this.props.store} />
                <span style={getSeperatorStyle()} />
                {this.getTimePicker()}
                {this.getShowTimeToggler()}
                {this.getUseNowToggler()}
                {this.showExtraOption()}
            </span>
        );

        function getStyle() {
            return {
                position: 'absolute',
                zIndex: 700,
                top: 40,
                left: 10,
                padding: 10,
                width: 234,
                border: '1px solid #BEBEBE',
                borderRadius: 5,
                background: 'white',
                boxShadow: '0 0 5px rgba(0, 0, 0, 0.4)'
            };
        }

        function getArrowUpStyle() {
            return {
                borderBottom: '10px solid white',
                borderRight: '10px solid transparent',
                borderLeft: '10px solid transparent',
                top: -10,
                left: 45,
                content: '',
                display: 'block',
                marginLeft: -10,
                position: 'absolute'
            };
        }

        function getSeperatorStyle() {
            return {
                display: 'block',
                height: 1,
                margin: '10px 5px',
                background: '#999'
            };
        }
    }

    getTimePicker() {
        return (
            <span style={{ display: 'block', padding: '5px 0' }}>
                <span style={{ marginLeft: 5, marginRight: 10 }}>{gettext('3142')}:</span>
                <TimePicker store={this.props.store} />
            </span>
        );
    }

    getShowTimeToggler() {
        if (!this.props.store.enableShowTimeToggler) {return;}

        return (
            <label style={{ display: 'block', padding: 5 }}>
                <input
                    type='checkbox'
                    style={{ marginRight: 3 }}
                    checked={!this.props.store.showTime}
                    onChange={() => this.props.store.toggleShowTime()}
                />
                <span style={{ marginLeft: 5 }}>{gettext('3118')}</span>
            </label>
        );
    }

    getUseNowToggler() {
        if (!this.props.store.enableUseNowOption) {return;}

        return (
            <span style={{ display: 'block', marginTop: 5 }}>
                <label style={{ padding: 5 }}>
                    <input
                        type='checkbox'
                        style={{ marginRight: 3 }}
                        checked={this.props.store.useNow}
                        onChange={() => this.props.store.toggleUseNow()}
                    />
                    <span style={{ marginLeft: 5 }}>{gettext('3188')}</span>
                </label>
            </span>
        );
    }

    showExtraOption() {
        if (!this.props.store.extraOptionCreator) {return;}

        const extraOption = this.props.store.createExtraOption();

        if (!extraOption) return;

        return (
            <span style={{ display: 'block', marginTop: 5 }}>
                <label style={{ display: 'flex', padding: 5 }}>
                    <span>
                        <input
                            type='checkbox'
                            style={{ marginRight: 3 }}
                            checked={this.props.store.useExtraOption}
                            onChange={this.props.store.handleToggleUseExtraOption}
                        />
                    </span>
                    <span style={{ marginLeft: 5 }}>
                        {extraOption}
                    </span>
                </label>
            </span>
        );
    }
}


@Radium
class DatePicker extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            month: getFirstDayOfMonth(props.store.date)
        };

        function getFirstDayOfMonth(date) {
            return new Date(date.getFullYear(), date.getMonth(), 1);
        }
    }

    render() {
        return (
            <span>
                {this.getMonthAndYearNode()}
                {this.getWeekDaysNode()}
                {this.getDaysNode()}
            </span>
        );
    }

    getMonthAndYearNode() {
        const that = this;

        return (
            <span style={{ display: 'flex', marginBottom: 5 }}>
                {this.getNavNode('left')}
                <span style={getMonthAndYearStyle()}>{getMonthAndYearText()}</span>
                {this.getNavNode('right')}
            </span>
        );

        function getMonthAndYearText() {
            return (
                getMonthName(that.state.month.getMonth()) +
                ' ' + that.state.month.getFullYear()
            );
        }

        function getMonthAndYearStyle() {
            return {
                flexGrow: 1,
                textAlign: 'center',
                fontWeight: 600,
                lineHeight: '30px'
            };
        }
    }

    getNavNode(direction) {
        return (
            <span
                key={'nav' + direction}
                style={getMonthNavButtonStyle()}
                className={'fa fa-angle-' + direction}
                onClick={() => this.setMonthOffset(direction === 'left' ? -1 : 1)}
            />
        );

        function getMonthNavButtonStyle() {
            return {
                width: 30,
                height: 30,
                lineHeight: '30px',
                textAlign: 'center',
                fontSize: 20,
                cursor: 'pointer',
                borderRadius: '5px',
                ':hover': {
                    background: '#E3E3E3'
                }
            };
        }
    }

    setMonthOffset(offset) {
        const month = this.state.month;
        month.setMonth(month.getMonth() + offset);
        this.setState({ month: month });
    }

    getWeekDaysNode() {
        return (
            <span style={{ display: 'flex', flexWrap: 'wrap' }}>
                {
                    _.map(getWeekDays(), day => {
                        return <span key={day} style={this.getDayBlockStyle()}>{day}</span>;
                    })
                }
            </span>
        );

        function getWeekDays() {
            return [
                gettext('3121'), gettext('3124'), gettext('3127'), gettext('3130'),
                gettext('3133'), gettext('3136'), gettext('3139')
            ];
        }
    }

    getDaysNode() {
        return (
            <span style={{ display: 'flex', flexWrap: 'wrap' }}>
                {this.getBlankDayNodes()}
                {this.getNumberedDayNodes()}
            </span>
        );
    }

    getBlankDayNodes() {
        return _.map(this.getBlankDays(), (day) => {
            return <span key={day} style={this.getDayBlockStyle()} />;
        });
    }

    getNumberedDayNodes() {
        return _.map(this.getDays(), day => {
            return this.getNumberedDayNode(day);
        });
    }

    getNumberedDayNode(day) {
        const that = this;

        return (
            <span
                key={day}
                style={getDayStyle()}
                onClick={getOnClick()}
            >
                {day}
            </span>
        );

        function getDayStyle() {
            return _.merge(
                that.getDayBlockStyle(),
                {
                    cursor: isEarlierThanMinDate() ? 'not-allowed' : 'pointer',
                    background: getBackgroundColor(),
                    color: isSelected() ? '#FFF' : null,
                    fontWeight: isSelected() ? 600 : null,
                    borderRadius: '5px',
                    opacity: isEarlierThanMinDate() ? 0.2 : 1,
                    ':hover': {
                        background: getBackgroundColor() || '#E3E3E3'
                    }
                }
            );

            function isSelected() {
                const month = that.state.month;
                const date = that.props.store.date;

                return (
                    month.getFullYear() === date.getFullYear() &&
                    month.getMonth() === date.getMonth() &&
                    day === date.getDate()
                );
            }

            function getBackgroundColor() {
                return isSelected() ? '#AD4C2C' : null;
            }
        }

        function getOnClick() {
            if (isEarlierThanMinDate()) {
                return null;
            } else {
                return that.chooseDate.bind(that, day);
            }
        }

        function isEarlierThanMinDate() {
            if (that.props.store.minDate) {
                return that.isEarlierThanMinDate(
                    day,
                    that.props.store.minDate.getHours(),
                    that.props.store.minDate.getMinutes()
                );
            }
        }
    }

    isEarlierThanMinDate(day, hours, minutes) {
        if (this.props.store.minDate) {
            const date = new Date(this.props.store.date);
            date.setFullYear(this.state.month.getFullYear());
            date.setMonth(this.state.month.getMonth());
            date.setDate(day);

            if (hours) date.setHours(hours);
            if (minutes) date.setMinutes(minutes);

            return date < this.props.store.minDate;
        } else {
            return false;
        }
    }

    getDayBlockStyle() {
        return {
            width: 30,
            height: 30,
            lineHeight: '30px',
            textAlign: 'center',
            userSelect: 'none'
        };
    }

    getBlankDays() {
        return _.range((6 + this.state.month.getDay()) % 7);
    }

    getDays() {
        const month = this.state.month;
        return _.range(
            1,
            1 + getDaysInMonth(
                month.getMonth(),
                month.getFullYear()
            )
        );
    }

    chooseDate(day) {
        const newDate = new Date(this.props.store.date);
        newDate.setFullYear(this.state.month.getFullYear());
        newDate.setMonth(this.state.month.getMonth());
        newDate.setDate(day);

        if (this.isEarlierThanMinDate(day)) {
            newDate.setHours(this.props.store.minDate.getHours());
            newDate.setMinutes(this.props.store.minDate.getMinutes());
        }

        this.props.store.setDate(newDate);
    }
}


class TimePicker extends React.Component {
    constructor(props) {
        super(props);

        this.width = 80;
        this.timePickerEl = null;
        this.state = Object.assign(
            {
                showCommonTimesDropdown: false
            },
            this.getStateForProps(props)
        );
    }

    componentDidMount() {
        this.onClickEventListener = event => {
            if (!this.timePickerEl.contains(event.target)) {
                this.hideDefaultTimesDropdown();
            }
        };

        document.addEventListener('click', this.onClickEventListener);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.onClickEventListener);
    }

    componentWillReceiveProps(props) {
        this.setState(this.getStateForProps(props));
    }

    getStateForProps(props) {
        return {
            inputValue: this.getDefaultInputValue(props.store.date)
        };
    }

    render() {
        return (
            <span
                style={{ position: 'relative' }}
                ref={ref => {this.timePickerEl = ref;}}
            >
                <input
                    type='text'
                    style={{ width: this.width, textAlign: 'center' }}
                    onFocus={this.handleShowCommonTimesDropdown}
                    onBlur={this.handleOnBlur}
                    onChange={this.handleOnChange}
                    onKeyDown={this.handleOnKeyDown}
                    value={this.state.inputValue}
                />
                {this.getCommonTimesDropdown()}
            </span>
        );
    }

    getCommonTimesDropdown() {
        return (
            <TimePickerCommonTimesDropdown
                store={this.props.store}
                visible={this.state.showCommonTimesDropdown}
                width={this.width}
                setCommonTime={this.setCommonTime}
            />
        );
    }

    setCommonTime = timeText => {
        this.setState({ inputValue: timeText });
        this.updateTime(timeText);
        this.hideDefaultTimesDropdown();
    }

    getDefaultInputValue(time) {
        return getTimeText(time.getHours(), time.getMinutes());
    }

    handleShowCommonTimesDropdown = () => {
        this.setState({ showCommonTimesDropdown: true });
    }

    hasCorrectInputValue() {
        const inputValues = getHoursAndMinutes(this.state.inputValue);
        const areValidValues = isValidHours(inputValues[0]) && isValidMinutes(inputValues[1]);

        if (areValidValues && this.props.store.minDate) {
            const date = new Date(this.props.store.date);
            date.setHours(inputValues[0]);
            date.setMinutes(inputValues[1]);

            if (date < this.props.store.minDate) {
                return false;
            }
        }

        return areValidValues;

        function isValidHours(hours) {
            return hours >= 0 && hours < 24;
        }

        function isValidMinutes(minutes) {
            return minutes >= 0 && minutes < 60;
        }
    }

    handleOnBlur = () => {
        if (this.hasCorrectInputValue()) {
            this.normalizeInputValue();
            this.updateTime(this.state.inputValue);
        } else {
            this.resetToDefaultInputValue();
        }
    }

    normalizeInputValue() {
        const inputValues = getHoursAndMinutes(this.state.inputValue);
        this.setState({ inputValue: getTimeText(inputValues[0], inputValues[1]) });
    }

    resetToDefaultInputValue() {
        this.setState({ inputValue: this.getDefaultInputValue(this.props.store.date) });
    }

    updateTime(newTimeText) {
        const newTimes = getHoursAndMinutes(newTimeText);

        const newTime = new Date(this.props.store.date);
        newTime.setHours(newTimes[0]);
        newTime.setMinutes(newTimes[1]);
        this.props.store.setDate(newTime);
    }

    hideDefaultTimesDropdown() {
        this.setState({ showCommonTimesDropdown: false });
    }

    handleOnChange = event => {
        this.setState({ inputValue: event.target.value });
    }

    handleOnKeyDown = event => {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.setState({ inputValue: event.target.value });
            this.normalizeInputValue();
            this.updateTime(this.state.inputValue);
            this.hideDefaultTimesDropdown();
        }
    }
}


@Radium
class TimePickerCommonTimesDropdown extends React.Component {
    constructor(props) {
        super(props);
        this.optionEls = {};
    }

    componentDidMount() {
        this.setScrollOffset();
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevProps.visible) {
            this.setScrollOffset();
        }
    }

    setScrollOffset() {
        const that = this;

        this.commonTimesPopupEl.scrollTop = getScrollOffset();

        function getScrollOffset() {
            const optionHeight = getOptionHeight();

            return that.optionEls['option-' + getClosestCommonTime()].offsetTop - optionHeight * 2;

            function getClosestCommonTime() {
                return getTimeText(
                    that.props.store.date.getHours(),
                    getClosestCommonMinutes()
                );

                function getClosestCommonMinutes() {
                    return (that.props.store.date.getMinutes() >= optionHeight) ? 30 : 0;
                }
            }

            function getOptionHeight() {
                return that.optionEls['option-00:00'].offsetHeight;
            }
        }
    }

    render() {
        const that = this;

        return (
            <span
                style={getContainerStyle()}
                ref={ref => {this.commonTimesPopupEl = ref;}}
            >
                {this.getTimeOptionNodes()}
            </span>
        );

        function getContainerStyle() {
            return {
                display: that.props.visible ? 'inline-block' : 'none',
                position: 'absolute',
                overflow: 'auto',
                left: 0,
                top: 28,
                height: 150,
                width: that.props.width,
                background: '#FFF',
                border: '1px solid #000',
                textAlign: 'center'
            };
        }
    }

    getTimeOptionNodes() {
        return _.map(_.range(24), (hours) => {
            return _.map([0, 30], (minutes) => {
                return this.getTimeOptionNode(hours, minutes);
            });
        });
    }

    getTimeOptionNode(hours, minutes) {
        const that = this;
        const timeText = getTimeText(hours, minutes);

        return (
            <span
                ref={ref => {this.optionEls['option-' + timeText] = ref;}}
                key={getTimeText(hours, minutes)}
                style={getStyle()}
                onClick={getOnClick()}
            >
                {timeText}
            </span>
        );

        function getStyle() {
            return {
                display: 'block',
                padding: '3px 5px',
                cursor: isEarlierThanMinDate() ? 'not-allowed' : 'default',
                ':hover': {
                    backgroundColor: '#E3E3E3'
                },
                opacity: isEarlierThanMinDate() ? 0.2 : 1
            };
        }

        function getOnClick() {
            if (isEarlierThanMinDate()) {
                return null;
            } else {
                return () => that.props.setCommonTime(timeText);
            }
        }

        function isEarlierThanMinDate() {
            return that.isEarlierThanMinDate(hours, minutes);
        }
    }

    isEarlierThanMinDate(hours, minutes) {
        if (this.props.store.minDate) {
            const time = new Date(this.props.store.date);
            time.setHours(hours);
            time.setMinutes(minutes);

            return time < this.props.store.minDate;
        } else {
            return false;
        }
    }
}
